import { FC, ComponentProps, useState, useEffect } from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { Box, Checkbox, Typography } from '@altermaind/web/ui';

type Props = {
  control: Control<FieldValues>;
  name: string;
  additonalProps?: Record<string, unknown>;
  containerCheckboxProps?: ComponentProps<typeof Box>;
  hasChildrenText?: string;
} & ComponentProps<typeof Checkbox>;

export const WrappedCheckbox: FC<Props> = ({
  control,
  name,
  additonalProps,
  containerCheckboxProps,
  hasChildrenText,
  ...props
}) => {
  const [checked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    if (props.checked) {
      setChecked(props.checked);
    }

    return () => {
      setChecked(false);
    };
  }, [props.checked]);

  return (
    <Controller
      control={control}
      name={name}
      rules={{ ...additonalProps }}
      render={({ field }) => (
        <Box
          onClick={
            props.disabled
              ? undefined
              : () => {
                  setChecked(!checked);
                  field.onChange(!checked);
                }
          }
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...containerCheckboxProps}
        >
          <Checkbox
            textStyle={{
              color: 'primary/text',
            }}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...field}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            checked={checked}
          />
          {hasChildrenText && (
            <Typography ml='xs' variant='p2/light'>
              {hasChildrenText}
            </Typography>
          )}
        </Box>
      )}
    />
  );
};
